import SupervisorCertificatesView from "@/requests/certificates/employmentCertificate/views/supervisor/viewSupervisor";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/_authenticated/requests/viewCertifiesRequests/viewSupervisor')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }

    const { isSupervisor } = context.userRoles;

    if (!isSupervisor) {
      throw redirect({ to: '/unauthorized' });
    }
  },

  component: SupervisorCertificatesView,

})